import {Component, Input, OnInit} from "@angular/core";
import {CurrencyItem} from "../../../objects/currencyExchange/currencyItem";
import {CurrencyEnum} from "../../../objects/currencyExchange/currencyEnum";
import {ColorHelper} from "../../../common/helpers/colorHelper";

/**
 * Created by alex.y on 7/19/2017.
 */
@Component({
    selector: "currency-chart",
    templateUrl: "./currencyChart.component.html",
    moduleId: module.id.toString()
})
export class CurrencyChartComponent implements OnInit {

    @Input()
    public currencyItems: Array<CurrencyItem> = [];

    /* Chart Settings Start */
    // lineChart
    public lineChartData: Array<any> = [];
    public lineChartLabels: Array<any> = [];
    public lineChartOptions: any = {
        responsive: true,
        legend: {
            position:'bottom',
            labels: {
                usePointStyle: true
            },
        }
    };
    public lineChartColors: Array<any> = []
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';
    /* Chart Settings End*/

    public excludeArray: Array<CurrencyEnum> = [CurrencyEnum.FXBRLCAD, CurrencyEnum.FXCNYCAD,
        CurrencyEnum.FXHKDCAD, CurrencyEnum.FXINRCAD, CurrencyEnum.FXIDRCAD, CurrencyEnum.FXMYRCAD, CurrencyEnum.FXNOKCAD, CurrencyEnum.FXPENCAD,
        CurrencyEnum.FXRUBCAD, CurrencyEnum.FXSARCAD, CurrencyEnum.FXSGDCAD, CurrencyEnum.FXZARCAD, CurrencyEnum.FXKRWCAD, CurrencyEnum.FXCHFCAD,
        CurrencyEnum.FXTWDCAD, CurrencyEnum.FXTHBCAD, CurrencyEnum.FXTRYCAD, CurrencyEnum.FXVNDCAD];

    public ngOnInit(): void {
        this.setChartData();
        this.generateColors();
    }

    private setChartData(): void {
        let i = 0;

        for (let item of this.currencyItems) {
            if (++i == 26)
                break;

            if (this.excludeArray.find(x => x.toString() == String.getEnumValue(item.Name, CurrencyEnum))) {
                continue;
            }

            var data = this.getCurrencyValues(item.Name);

            this.lineChartData.push({
                data: data,
                label: String.getEnumValue(item.Name, CurrencyEnum)
            });
        }
    }

    private getCurrencyValues(name: string, addLabel: boolean = true): Array<number> {
        let items = this.currencyItems.filter(x => x.Name == name);

        let itemValues = new Array<number>();

        for (let it of items) {
            if (it.Value < 0)
                continue;

            itemValues.push(it.Value);

            if (!addLabel)
                continue;

            let date = String.formatDateMMDDYYYY(it.Date.toString());

            if (!this.lineChartLabels.find(x => x == date))
                this.lineChartLabels.push(date);
        }

        return itemValues;
    }

    private generateColors(): void {
        for (let i = 1; i < /*this.lineChartLabels.length + 1*/9 ; i++) {
            let color = ColorHelper.colorGenerate(this.lineChartLabels.length + 1 , i*8);

            this.lineChartColors.push({
                fill: false,
                backgroundColor: color,
                borderColor: color,
                pointBackgroundColor: color,
                pointBorderColor: `#fff`,
                pointHoverBackgroundColor: `#fff`,
                pointHoverBorderColor: color,
            })
        }
    }
}


// WEBPACK FOOTER //
// ./app/components/currencyExchange/currencyChart/currencyChart.component.ts